import { Link } from "react-router-dom";
import { useState, useEffect } from "react";


export default function AboutFirm() {
  const [activeQuote, setActiveQuote] = useState(0);


  const quotes = [
    {
      quote: "Justice delayed is justice denied. We ensure timely resolution with unwavering commitment.",
      author: "Our Founding Principle"
    },
    {
      quote: "Law is not merely practiced it is upheld with responsibility, precision, and purpose.",
      author: "Our Professional Ethos"
    },
    {
      quote: "Every case deserves strategy, diligence, and fearless advocacy.",
      author: "Our Litigation Philosophy"
    },
    {
      quote: "Client trust is earned through integrity, not promises.",
      author: "Our Core Value"
    },
    {
      quote: "Results are achieved where preparation meets determination.",
      author: "Our Approach"
    },
    {
      quote: "Legal excellence is measured by outcomes and the confidence we deliver.",
      author: "Our Standard"
    },
    {
      quote: "We protect rights, manage risk, and deliver clarity in complexity.",
      author: "Our Commitment"
    },
    {
      quote: "Strong advocacy begins with understanding, and succeeds with execution.",
      author: "Our Belief"
    }
  ];


  // Auto-rotate quotes every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveQuote((prev) => (prev + 1) % quotes.length);
    }, 5000);


    return () => clearInterval(interval);
  }, [quotes.length]);


  return (
    <section className="relative overflow-hidden py-20 sm:py-24 bg-gradient-to-b from-[#f7f3ec] to-[#faf8f4]">


      {/* BACKGROUND GRAPHICS */}
      <div className="absolute -top-24 -left-24 w-72 h-72 bg-[#123a6f]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 -right-24 w-80 h-80 bg-yellow-400/10 rounded-full blur-3xl" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(18,58,111,0.06),transparent_50%)]" />


      {/* TOP DIVIDER */}
      <div className="absolute top-0 left-0 w-full h-px bg-[#123a6f]/20" />


      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-5 gap-16 items-stretch">


          {/* LEFT CONTENT */}
          <div className="lg:col-span-2 flex flex-col justify-center">


            <h2 className="font-playfair text-3xl sm:text-4xl xl:text-5xl font-bold text-[#0b1c2d] leading-tight">
              About Our Firm
            </h2>


            <p className="mt-4 text-lg font-semibold text-[#123a6f]">
              Committed to Legal Excellence & Client Success
            </p>


            <p className="mt-6 text-gray-700 leading-relaxed max-w-xl">
              <span className="font-semibold text-[#0b1c2d]">
                Blackthorn Chambers
              </span>{" "}
              is a premier law firm with a distinguished track record of
              delivering exceptional legal services. Our experienced advocates
              and legal consultants bring together diverse expertise to resolve
              even the most complex legal matters with precision and dedication.
            </p>


            <p className="mt-4 text-gray-700 leading-relaxed max-w-xl">
              We follow a client-centric approach, ensuring personalized
              attention to every case while upholding the highest standards of
              professional ethics, transparency, and confidentiality.
            </p>


            <div className="mt-8">
              <Link
                to="/about"
                className="
                  group inline-flex items-center gap-3
                  px-10 py-3
                  bg-[#0b1c2d] text-white
                  font-semibold tracking-wide
                  border border-[#0b1c2d]
                  hover:bg-transparent hover:text-[#0b1c2d]
                  transition-all duration-300
                  relative
                "
              >
                {/* GOLD ACCENT LINE */}
                <span className="absolute left-0 top-0 h-full w-1 bg-yellow-400 group-hover:w-full group-hover:opacity-10 transition-all duration-300"></span>


                <span className="relative z-10">Learn More</span>


                <span className="relative z-10 transform group-hover:translate-x-1 transition">
                  →
                </span>
              </Link>
            </div>
          </div>


          {/* RIGHT — WIDER QUOTE SLIDER */}
          <div className="lg:col-span-3 relative bg-[#0b1c2d] p-10 sm:p-16 overflow-hidden min-h-[400px] flex flex-col">


            {/* QUOTE SLIDES */}
            <div className="flex-1 relative flex items-center justify-center">
              <div className="w-full max-w-3xl relative h-64">
                {quotes.map((item, index) => (
                  <div
                    key={index}
                    className={`absolute inset-0 flex flex-col items-center justify-center px-6 transition-all duration-700 ${
                      index === activeQuote
                        ? 'opacity-100 translate-x-0'
                        : index < activeQuote
                        ? 'opacity-0 -translate-x-full'
                        : 'opacity-0 translate-x-full'
                    }`}
                  >
                    <p className="text-xl sm:text-2xl leading-relaxed text-white text-center">
                      "{item.quote}"
                    </p>


                    <span className="block mt-8 text-sm uppercase tracking-widest text-yellow-400 font-semibold">
                      {item.author}
                    </span>
                  </div>
                ))}
              </div>
            </div>


            {/* INDICATOR DOTS */}
            <div className="flex justify-center gap-2 mt-8">
              {quotes.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveQuote(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === activeQuote
                      ? 'bg-yellow-400 w-8'
                      : 'bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Go to quote ${index + 1}`}
                />
              ))}
            </div>


            {/* CORNER SQUARE - YEARS */}
            <div className="absolute top-0 right-0 w-16 h-16 bg-yellow-400 text-[#0b1c2d] flex items-center justify-center font-bold text-xl">
              25+
            </div>
          </div>


        </div>
      </div>
    </section>
  );
}
